import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../assets/css/register-success.css";
import { useAccountRegisterStore } from "../../stores/useAccountRegisterStore";
import Header from "../Header/HeaderComponent";
import { useTranslation } from "react-i18next";

const FormSuccess = ({ pageData }) => {
  const navigate = useNavigate();
  const [first, setFirst] = useState("");
  const [second, setSecond] = useState("");
  const { t } = useTranslation("register");
  const idCard = useAccountRegisterStore((state) => state.idCard);

  const dob = useAccountRegisterStore((state) => state.dob);

  useEffect(() => {
    setFirst(idCard);
    setSecond(dob);
  }, [idCard, dob]);

  const handleGoToProfile = () => {
    navigate("/profile");
  };

  function handleGoToSelectLoan() {
    navigate("/select-loan");
  }

  return (
    <div id="PageFormSuccess" className="s">
      <Header title="" showIcon={true} onBack={true} />
      <div className="wrapContent">
        <div id="pFormSuccess">
          <div className="bContent">
            <div className="bSuccess">
              <div className="bImg">
                <img src="/assets/img/ci/icon/check-circle.svg" alt="Success" />
                <div className="tText">
                  <h3>{t("success1")}</h3>
                  <h3>{t("success2")}</h3>
                </div>
              </div>
              <div className="bAction">
                <button className="primary" onClick={handleGoToSelectLoan}>
                  {t("success3")}
                </button>
                {/* 🎉 Navigate to /profile with state when clicking this button */}
                <button className="secondary" onClick={handleGoToProfile}>
                  {t("success4")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormSuccess;
